<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="center"><em class="italic">For Dion, Jim, and Betsey, Guardian angels in the truest sense</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?b012a65c